export const insertItemIntoArray = <Item>(array: Item[], item: Item, itemIndex: number): Item[] => [
    ...array.slice(0, itemIndex),
    item,
    ...array.slice(itemIndex),
];
